module.exports = __webpack_public_path__ + "static/mint-20bc27aef5f29f81a1582e8f0b319ea1.png";